/* MCD Policy-Sprach-Toggle (Jonas 17.07.2026): Rechtstexte sind zweisprachig in
   EINEM Body (DE zuerst, Marker "English version below", dann EN). Dieses Script
   teilt die Seite am Marker und baut einen EN/DE-Umschalter — Storefront ist
   englisch, also startet EN; Hinweis "German version is legally binding" bleibt
   immer sichtbar. Die gespeicherten Policy-Texte werden NICHT veraendert. */
(function () {
  function init() {
    var body = document.querySelector(".shopify-policy__body");
    if (!body) return;

    /* Marker-Absatz finden: <p><strong>English version below</strong></p> */
    var marker = null;
    body.querySelectorAll("p").forEach(function (p) {
      if (!marker && /^english version below$/i.test(p.textContent.trim())) marker = p;
    });
    if (!marker) return; /* einsprachige Policy (z.B. Contact) — nichts tun */
    /* Inhalt lebt in einem Wrapper (div.rte) — dort splitten, wo der Marker direktes Kind ist */
    var root = marker.parentElement;

    var de = document.createElement("div");
    var en = document.createElement("div");
    var target = de;
    Array.prototype.slice.call(root.childNodes).forEach(function (n) {
      if (n === marker) { target = en; root.removeChild(n); return; }
      target.appendChild(n);
    });

    /* DE-Zeiger-Satz ("...englische Fassung ... scrollen ... nach unten") ist mit
       Toggle falsch — ausblenden */
    de.querySelectorAll("p").forEach(function (p) {
      var t = p.textContent;
      if (/englische Fassung/i.test(t) && /scrollen/i.test(t)) p.style.display = "none";
    });

    var css = document.createElement("style");
    css.textContent =
      ".mcd-poltog{display:flex;align-items:center;gap:10px;margin:0 0 14px;}" +
      ".mcd-poltog button{font:600 12px/1 inherit;letter-spacing:.14em;text-transform:uppercase;" +
      "padding:9px 18px;border:1px solid rgba(127,127,127,.45);background:transparent;color:inherit;" +
      "border-radius:999px;cursor:pointer;opacity:.65;}" +
      ".mcd-poltog button[aria-pressed=true]{opacity:1;border-color:currentColor;font-weight:700;}" +
      ".mcd-poltog-note{font-size:12px;opacity:.65;margin:0 0 26px;}";
    document.head.appendChild(css);

    var bar = document.createElement("div");
    bar.className = "mcd-poltog";
    var note = document.createElement("p");
    note.className = "mcd-poltog-note";
    var bEN = document.createElement("button");
    var bDE = document.createElement("button");
    bEN.type = bDE.type = "button";
    bEN.textContent = "English";
    bDE.textContent = "Deutsch";
    bar.appendChild(bEN);
    bar.appendChild(bDE);

    function show(lang) {
      var isEN = lang === "en";
      en.hidden = !isEN;
      de.hidden = isEN;
      bEN.setAttribute("aria-pressed", isEN ? "true" : "false");
      bDE.setAttribute("aria-pressed", isEN ? "false" : "true");
      note.textContent = isEN
        ? "The German version is legally binding — this English translation is provided for convenience."
        : "Die deutsche Fassung ist rechtlich bindend.";
    }
    bEN.addEventListener("click", function () { show("en"); });
    bDE.addEventListener("click", function () { show("de"); });

    root.appendChild(bar);
    root.appendChild(note);
    root.appendChild(en);
    root.appendChild(de);
    show("en"); /* Storefront-Sprache */
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
